import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_JOB_BOARD_API_URL;

// =======================
// STATS
// =======================
export const getJobSeekerStats = async (token) => {
  const res = await axios.get(
    `${API_BASE_URL}/admin/job-seekers/stats`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return res.data;
};

// =======================
// LIST + FILTERS + PAGINATION
// =======================
export const getJobSeekers = async (params, token) => {
  const res = await axios.get(
    `${API_BASE_URL}/admin/job-seekers`,
    {
      params,
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return res.data;
};

// =======================
// VIEW SINGLE
// =======================
export const getJobSeekerById = async (id, token) => {
  const res = await axios.get(
    `${API_BASE_URL}/admin/job-seekers/${id}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return res.data;
};

// =======================
// UPDATE VERIFICATION
// =======================
export const updateJobSeekerVerification = async (id, status, token) => {
  await axios.patch(
    `${API_BASE_URL}/admin/job-seekers/${id}/verification`,
    { status },
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};

// =======================
// UPDATE STATUS working code commented. dont change. this is for Status cloumn
// =======================
// export const updateJobSeekerStatus = async (id, status, token) => {
//   await axios.patch(
//     `${API_BASE_URL}/admin/job-seekers/${id}/status`,
//     { status },
//     {
//       headers: { Authorization: `Bearer ${token}` }
//     }
//   );
// };



// =======================
// UPDATE PLAN
// =======================
export const updateJobSeekerPlan = async (id, plan, token) => {
  await axios.patch(
    `${API_BASE_URL}/admin/job-seekers/${id}/plan`,
    { plan },
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};

// =======================
// BULK ACTIONS
// =======================
export const bulkJobSeekerAction = async (payload, token) => {
  await axios.post(
    `${API_BASE_URL}/admin/job-seekers/bulk`,
    payload,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
};

// =======================
// EXPORT
// =======================
export const exportJobSeekers = async (token) => {
  const res = await axios.get(
    `${API_BASE_URL}/admin/job-seekers/export`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  return res.data;
};
